import { Column } from "@bridgesplit/ui";

import DepositAmounts from "./DepositAmounts";
import DepositCtaStats from "./DepositCtaStats";
import ManagePositionWrapper from "../../clmm/ManagePositionWrapper";
import DepositCta from "./DepositCta";
import { useRaydiumContext } from "../RaydiumContext";

function DepositTop() {
    return <DepositAmounts />;
}

function DepositBottom() {
    const context = useRaydiumContext();

    return (
        <Column spacing={2}>
            <DepositCtaStats />
            <ManagePositionWrapper context={context} actionType="deposit">
                <DepositCta />
            </ManagePositionWrapper>
        </Column>
    );
}

export const Deposit = {
    Top: DepositTop,
    Bottom: DepositBottom
};
